<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input
                v-model="queryParam.keywords"
                allowClear
                placeholder="搜索关键字"
              />
            </a-form-item>
          </a-col>
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="danwei" slot-scope="text, record">
        <div style="margin-left: 10px; float: left">
          {{ record.name }}
          <br />
          身份证号:{{ record.num }}
          <br />
          手机号:{{ record.phone }}
          <br />
          证书编号:{{ record.code }}
        </div>
      </span>
      <span slot="face" slot-scope="text, record">
        <template>
        <img
          :width="100"
          :src=record.face
        />
        </template>
        <!-- <p v-show="record.code>0"><a-tag>{{record.code}}</a-tag></p>
        <p v-if="record.wudaograde">{{record.wudaograde}}级</p> -->
        <!--        <p v-if="record.jiqiaograde">{{record.jiqiaograde}}级</p>-->
      </span>
      <span slot="grade" slot-scope="text, record">
        {{ record.grade }}
        <!-- <p v-show="record.code>0"><a-tag>{{record.code}}</a-tag></p>
        <p v-if="record.wudaograde">{{record.wudaograde}}级</p> -->
        <!--        <p v-if="record.jiqiaograde">{{record.jiqiaograde}}级</p>-->
      </span>
      <span slot="status" slot-scope="text, record">
        <a-tag v-if="record.status == 2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status == 1" color="red">待审核</a-tag>
        <a-tag v-else-if="record.status == 3">审核失败</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a v-if="record.pdf_url" @click="downloadCert(record)">下载证书</a>
        </template>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import EditableCell from "@/components/EditableCell/";
import PicUploader from "@/components/PicUploader/";
import FileUploader from "@/components/FileUploader/";
import JiaolianPicker from "@/components/JiaolianPicker/";
import areaOptions from "@/utils/area";
import moment from "moment";
import qs from "qs";
import setting from "@/config/setting";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

import { getyeyuList } from "@/api/yeyumember";
export default {
  name: "Yeyudengjimemberlist",
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
    JiaolianPicker,
  },
  data() {
    return {
      areaOptions,
      visible: false,
      orderVisible: false,
      saveLoading: false,
      userFormVisible: false,
      jiaolianPickerShow: false,
      jiaolianPickerShow: false,
      sjsqOptions: [],
      orderFormData: {},
      formData: {
        id: 0,
        danwei: "",
        areas: [],
        member_list: [],
        loglist: [],
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: "",
        // p:1,
        // step:10
      },
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "人员信息",
          dataIndex: "danwei",
          scopedSlots: { customRender: "danwei" },
        },
        {
          title: "照片",
          dataIndex: "face",
          scopedSlots: { customRender: "face" },
        },
        {
          title: "等级",
          dataIndex: "grade",
          scopedSlots: { customRender: "grade" },
        },
        {
          title: "状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 240,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format("YYYY-MM-DD HH:mm:ss"),
            this.time_range_moment[1].format("YYYY-MM-DD HH:mm:ss"),
          ];
        } else {
          this.queryParam.time_range = [];
        }

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getyeyuList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: "",
        price: 0,
        note: "",
        count: 0,
      },
      serviceTypeOptions: [],
      userFormData: {},
    };
  },
  computed: {},

  created() {},

  mounted() {
    let that = this;

    let query = this.$route.query;
    // 6, 276
    console.log(query);
    if (query.saiji) {
      this.queryParam.sjsq = [query.saiji, query.saiqu];
    }
    that.getSjsqOptions();
  },
  methods: {
    moment,
    getSjsqOptions() {
      let that = this;
      sjsqOptions({}).then((res) => {
        that.sjsqOptions = res.data;
      });
    },
    handleCancel() {
      this.visible = false;
    },
    handleOrderCancel() {
      this.orderVisible = false;
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },

    handleUserFormCancel() {
      this.userFormVisible = false;
    },

    download(type) {
      console.log("this.queryParam");
      console.log(this.queryParam);
      // if (typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length != 2) {
      // this.$message.error('请先选择赛区');
      // return;
      // }
      switch (type) {
        case 1:
          window.open(
            setting.apiBaseURL +
              "/adminapi/jiaolian/shengJlDownload?" +
              qs.stringify(this.queryParam)
          );
          break;
      }
    },
    downloadCert(record) {
      window.open(record.pdf_url);
    },
    refreshCert(record) {
      const hide = this.$message.loading("生成中..", 0);
      refreshCert({ id: record.id }).then((res) => {
        this.$message.success("证书生成成功");
        setTimeout(hide, 0);
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
  },
  filters: {},
  watch: {},
};
</script>
